var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimelinePendingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "#B4B4B4",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "#B4B4B4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.9165 17.833H16.0832M7.9165 6.16406H16.0832M14.9166 17.8319V15.3982C14.9166 15.0888 14.7936 14.7921 14.5748 14.5734L12 11.9985L9.42515 14.5734C9.20634 14.7921 9.08338 15.0888 9.08331 15.3982V17.8319M9.08331 6.16406V8.59773C9.08338 8.90712 9.20634 9.20382 9.42515 9.42256L12 11.9974L14.5748 9.42256C14.7936 9.20382 14.9166 8.90712 14.9166 8.59773V6.16406",
    stroke: "#B4B4B4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimelinePendingIcon);
export default __webpack_public_path__ + "static/media/timeline_pending_icon.6612ff6e48542201d645b0649d0d191e.svg";
export { ForwardRef as ReactComponent };